import { DataBean } from "../DataBean";

export class NoteImp extends DataBean {

    public async getNoteImpCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService("BpmService", "java.util.List_getNoteImpCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async deleteNoteImp(idnoteimp: number): Promise<any> {
        return this.getCustomService("BpmService", "boolean_deleteNoteImp_Number", [idnoteimp]);
    }

    public async updateNoteImp(bean: any): Promise<any> {
        return this.getCustomService("BpmService", "com.quickbpm.bean.NoteImp_updateNoteImp_com.quickbpm.bean.NoteImp", [{
            "DataBeanProperties": bean,
            "DataBeanName": "com.quickbpm.bean.NoteImp"
        }]);
    }

}